/**
 * Schutz vor dem Verlassen mit ungespeicherten Änderungen.
 *
 * React Router läuft hier über `<BrowserRouter>`, nicht über einen Data Router —
 * `useBlocker` steht damit nicht zur Verfügung. Statt den Router umzubauen,
 * meldet die bearbeitende Seite hier einen Handler an, und die Navigation im
 * Layout fragt vor jedem Wechsel nach.
 *
 * Der Handler liefert `true` (weiter) oder `false` (abbrechen) — was dazwischen
 * passiert (Dialog, Speichern), entscheidet die Seite selbst.
 */

type LeaveHandler = () => Promise<boolean>;

let activeHandler: LeaveHandler | null = null;

/**
 * Meldet einen Handler an. Rückgabe ist die Abmeldefunktion — direkt als
 * Cleanup eines useEffect verwendbar.
 */
export function registerUnsavedGuard(handler: LeaveHandler): () => void {
  activeHandler = handler;
  return () => {
    if (activeHandler === handler) activeHandler = null;
  };
}

/** Fragt den angemeldeten Handler. Ohne Handler ist der Weg immer frei. */
export async function confirmNavigation(): Promise<boolean> {
  if (!activeHandler) return true;
  return activeHandler();
}

/** Gibt es gerade eine Seite mit ungespeicherten Änderungen? */
export function hasUnsavedGuard(): boolean {
  return activeHandler !== null;
}
